import axios from "axios";
import { getAuth } from "firebase/auth";

const instance = axios.create({
  baseURL: window.location.hostname === "localhost"
    ? "https://modularobjects.com/checkout/api"
    : "https://modularobjects.com/checkout/api",
  withCredentials: false,
});

instance.interceptors.request.use(async (config) => {
  const auth = getAuth();
  const user = auth.currentUser;

  if (user) {
    const token = await user.getIdToken();
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

export default instance;